import "regenerator-runtime/runtime";
import _asyncToGenerator from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
// 获取列表内容封装在mixins内部  getTableData方法 初始化已封装完成 条件搜索时候
//请把条件安好后台定制的结构体字段 放到 this.searchInfo 中即可实现条件搜索

import { getApiById, getApiList, createApi, updateApi, deleteApi as _deleteApi } from '@/api/api';
import infoList from '@/components/mixins/infoList';
import { toSQLLine } from '@/utils/stringFun';
var methodOptions = [{
  value: 'POST',
  label: 'Create',
  type: 'success'
}, {
  value: 'GET',
  label: 'Read',
  type: ''
}, {
  value: 'PUT',
  label: 'Update',
  type: 'warning'
}, {
  value: 'DELETE',
  label: 'Delete',
  type: 'danger'
}];
export default {
  name: 'Api',
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getApiList,
      dialogFormVisible: false,
      dialogTitle: this.$t('api.add'),
      form: {
        path: '',
        apiGroup: '',
        method: '',
        description: ''
      },
      methodOptions: methodOptions,
      type: '',
      rules: {
        path: [{
          required: true,
          message: this.$t('api.path_required'),
          trigger: 'blur'
        }],
        apiGroup: [{
          required: true,
          message: this.$t('api.group_required'),
          trigger: 'blur'
        }],
        method: [{
          required: true,
          message: this.$t('api.request_required'),
          trigger: 'blur'
        }],
        description: [{
          required: true,
          message: this.$t('api.description_required'),
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    // 排序
    sortChange: function sortChange(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      if (prop) {
        this.searchInfo.orderKey = toSQLLine(prop);
        this.searchInfo.desc = order == 'descending';
      }
      this.getTableData();
    },
    //条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    initForm: function initForm() {
      this.$refs.apiForm.resetFields();
      this.form = {
        path: '',
        apiGroup: '',
        method: '',
        description: ''
      };
    },
    closeDialog: function closeDialog() {
      this.initForm();
      this.dialogFormVisible = false;
    },
    openDialog: function openDialog(type) {
      switch (type) {
        case 'addApi':
          this.dialogTitle = this.$t('common.add');
          break;
        case 'edit':
          this.dialogTitle = this.$t('common.edit');
          break;
        default:
          break;
      }
      this.type = type;
      this.dialogFormVisible = true;
    },
    editApi: function () {
      var _editApi = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(row) {
        var res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return getApiById({
                id: row.ID
              });
            case 1:
              res = _context.sent;
              this.form = res.data.api;
              this.openDialog('edit');
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function editApi(_x) {
        return _editApi.apply(this, arguments);
      }
      return editApi;
    }(),
    deleteApi: function () {
      var _deleteApi2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(row) {
        var _this = this;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.$confirm(this.$t('common.delete_warning'), '', {
                confirmButtonText: this.$t('common.confirm'),
                cancelButtonText: this.$t('common.cancel'),
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var res;
                return regeneratorRuntime.wrap(function (_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 1;
                      return _deleteApi(row);
                    case 1:
                      res = _context2.sent;
                      if (res.code == 0) {
                        _this.$message({
                          type: 'success',
                          message: _this.$t('common.success')
                        });
                        _this.getTableData();
                      }
                    case 2:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }))).catch(function () {
                _this.$message({
                  type: 'info',
                  message: _this.$t('common.canceled')
                });
              });
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function deleteApi(_x2) {
        return _deleteApi2.apply(this, arguments);
      }
      return deleteApi;
    }(),
    enterDialog: function () {
      var _enterDialog = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this2 = this;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.$refs.apiForm.validate(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(valid) {
                  var res, _res, _t;
                  return regeneratorRuntime.wrap(function (_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!valid) {
                          _context4.next = 6;
                          break;
                        }
                        _t = _this2.type;
                        _context4.next = _t === 'addApi' ? 1 : _t === 'edit' ? 3 : 5;
                        break;
                      case 1:
                        _context4.next = 2;
                        return createApi(_this2.form);
                      case 2:
                        res = _context4.sent;
                        if (res.code == 0) {
                          _this2.$message({
                            type: 'success',
                            message: _this2.$t('common.sucess'),
                            showClose: true
                          });
                        }
                        _this2.getTableData();
                        _this2.closeDialog();
                        return _context4.abrupt("continue", 6);
                      case 3:
                        _context4.next = 4;
                        return updateApi(_this2.form);
                      case 4:
                        _res = _context4.sent;
                        if (_res.code == 0) {
                          _this2.$message({
                            type: 'success',
                            message: _this2.$t('common.success'),
                            showClose: true
                          });
                        }
                        _this2.getTableData();
                        _this2.closeDialog();
                        return _context4.abrupt("continue", 6);
                      case 5:
                        _this2.$message({
                          type: 'error',
                          message: _this2.$t('common.error'),
                          showClose: true
                        });
                        return _context4.abrupt("continue", 6);
                      case 6:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function enterDialog() {
        return _enterDialog.apply(this, arguments);
      }
      return enterDialog;
    }()
  },
  filters: {
    methodFiletr: function methodFiletr(value) {
      var target = methodOptions.filter(function (item) {
        return item.value === value;
      })[0];
      // return target && `${target.label}(${target.value})`
      return target && "".concat(target.label);
    },
    tagTypeFiletr: function tagTypeFiletr(value) {
      var target = methodOptions.filter(function (item) {
        return item.value === value;
      })[0];
      return target && "".concat(target.type);
    }
  },
  created: function created() {
    this.getTableData();
  }
};